import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AppService, CoreProxyService, CoreTypes, IncidentTypes, LabelValue, Modal, StringDateTimePipe, TableTypes } from 'common-cloudstudio';
import { IncidentElementModalComponent } from '../incident-element-modal/incident-element-modal.component';
import { IncidentService } from '../../services/incident.service';
import moment from 'moment';


export interface ITS_PersonsData extends CoreTypes.ITS_IncidentPersons, CoreTypes.ITS_Persons {
  VehicleDataID?:number,
  Id?: number
 }

 export interface ITS_Dispatches extends CoreTypes.ITS_IncidentAssistanceDispatch {
  TransferEndDateTime?: CoreTypes.DateTimeDT;
  Identification?: string;
  Observation?: string;
}


@Component({
  selector: 'app-incident-tables',
  templateUrl: './incident-tables.component.html',
  styleUrls: ['./incident-tables.component.scss'],
})
export class IncidentTablesComponent implements OnInit, OnDestroy {
  today = new Date();
  @ViewChild('elementModal') private _elementModal: IncidentElementModalComponent;
  @ViewChild('confirmRemove') private _confirmRemove: Modal;

  @Input() incidentID: number = 0;
  @Input() incidentClose: boolean = false;
  @Input() loadAssistances: number;
  @Input() loadDataLanes: number;
  @Input() loadDataVehicles: number;
  @Input() loadDataPersons: number;
  @Input() loadAddVehicles: number;
  @Input() loadAddPersons: number;
  @Input() displayOnlyFileEvidence: boolean = false;
  @Input() displayOnIncidentFile: boolean = false;
  @Input() displayOnModal: boolean = false;
  @Input() vialAxes: any;
  @Input() incidentData: CoreTypes.ITS_Incident;
  @Input() incidentFileData: any;
  @Input() vehicleDataFullList:CoreTypes.ITS_VehiclesData[] = [];
  @Input() personDataFullList:CoreTypes.ITS_Persons[] = [];

  @Output() updateSummary = new EventEmitter<any>();

  incidentElements: IncidentTypes.IncidentElementModal;
  incidentElementTypes = IncidentTypes.elementTypes;

  _removeId: number;
  _removeType: string;
  _editId: number;
  _editType: string;
  _editTitle: string;

  dateTimeCreated: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: this.today.getDate(),
      Month: this.today.getMonth()+1,
      Year: this.today.getFullYear()
    },
    Time: {
      Hour: this.today.getHours(),
      Minute: this.today.getMinutes(),
      Second: this.today.getSeconds(),
      Millisecond: this.today.getMilliseconds(),
    }
  };
  fileTypeMapping = IncidentTypes.FileTypeMapping;

  _vehiclesInvolvedList: any[] = [];
  _vehiclesInvolvedListClone: IncidentTypes.ITS_VehiclesData[] = [];
  _peopleInvolvedList: any[] = [];
  _peopleInvolvedListClone: ITS_PersonsData[] = [];
  _dispatchList: any[] = [];
  _dispatchTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _lanesInvolvedTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _vehiclesInvolved: TableTypes.DataTable = { Columns: [], Elements: [] };
  _peopleInvolved: TableTypes.DataTable = { Columns: [], Elements: [] };
  _damageRegisterDataTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _fileEvidenceTable: TableTypes.DataTable = { Columns: [], Elements: [] };
  _lanesInvolvedList: any[] = [];
  _fileEvidenceList: any[] = [];
  _damageRegisterList: any[] = [];
  _vehicleModelFullList: CoreTypes.ITS_VehicleModels[] = [];
  _vehicleModelList: LabelValue<number>[] = [];
  _vehicleTypeList: LabelValue<number>[] = [];
  _vehicleColorList: LabelValue<number>[] = [];
  _vehiclePersonList: LabelValue<number>[] = [{label: 'Ninguno',value: 0}];
  _vehiclePerson: LabelValue<number>;
  _reasonLaneCloseList: LabelValue<number>[] = [];
  _reasonLaneOpenList: LabelValue<number>[] = [];

  _vialAxesList: LabelValue<number>[] = [];
  _roadwayFullList: CoreTypes.ITS_Roadways[] = [];
  _laneRoadwayList: LabelValue<number>[] = [];
  _laneRoadway: LabelValue<number>;
  _laneFullList: CoreTypes.ITS_Lanes[] = [];
  _laneClone: CoreTypes.ITS_IncidentLanes = new CoreTypes.ITS_IncidentLanes();
  _assistanceClone: ITS_Dispatches = new CoreTypes.ITS_IncidentAssistanceDispatch();
  _assistanceReasonList: CoreTypes.ITS_VehicleAssistanceReasons[] = [];
  _personAssistanceReasonList: CoreTypes.ITS_PersonAssistanceReasons[] = [];
  _trafficDirectionsList: LabelValue<number>[] = [];
  damageRegister: CoreTypes.ITS_IncidentDamagedMaterialAssets = new CoreTypes.ITS_IncidentDamagedMaterialAssets();
  materialAssetsFullList: CoreTypes.ITS_MaterialAssets[] = [];
  summaryConditions: any;
  involvedVehicleClone: IncidentTypes.ITS_VehiclesData = { ...new CoreTypes.ITS_VehiclesData(), ...new CoreTypes.ITS_Persons(), ...new CoreTypes.ITS_IncidentVehicles() };
  involvedPerson: ITS_PersonsData = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
  involvedPersonClone: ITS_PersonsData = {... new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };

  _countries:LabelValue<number>[] = new Array<LabelValue<number>>();
  _movilList: LabelValue<number>[] = [];
  _externalMovilFullList: CoreTypes.ITS_ExternalAssistanceServices[] = [];
  _externalMovilList: LabelValue<number>[] = [];
  _assistanceFullList: CoreTypes.ITS_AssistanceTypes[] = [];
  _assistanceList: LabelValue<number>[] = [];

  constructor(
    public _appService: AppService,
    private cdRef: ChangeDetectorRef,
    private incidentService: IncidentService,
    private stringDateTimePipe: StringDateTimePipe,
    private _coreProxyService: CoreProxyService
  ) {}

  ngOnInit(): void {
    this.refreshTabsData();
    this.appendModalBody('append');
  }

  ngOnDestroy(): void {
    this.appendModalBody('remove');
  }

  async getITSAssistanceTypes() {
    this._assistanceFullList = [];
    this._assistanceList = [];
    try {
      const assistence = await this.incidentService.getAssistenceTypes();
      this._assistanceFullList = assistence || [];
      if (!assistence.length) {
        this.incidentService._assistenceTypeStatus = 0;
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      const assistanceTypeList = await this.incidentService._assistenceTypeList?.value;
      this._assistanceList = assistanceTypeList || [];
      this.cdRef.detectChanges();
    } catch (error) {}
  }

  async getAssets() {
    // this._assetsFullList = [];
    this._movilList = [];
    let movilList = await this.incidentService.getAssetsList();
    this._movilList = JSON.parse(JSON.stringify(movilList))
    await this.incidentService._assetsList.value;
  }

  async getITSExternalAssistanceServices() {
    this._externalMovilList = [];
    this._externalMovilFullList = [];
    this._externalMovilList = await this.incidentService.getITSExternalAssistanceServices();
    this._externalMovilFullList = await this.incidentService._externalServiceList.value;
  }

  async onSelectTrafficDirection() {
    this._trafficDirectionsList = await this.incidentService.getITSTrafficDirections();
    this.cdRef.detectChanges();
  }
  
  async getITSReasonsClosing() {
    await this.incidentService.getITSReasonsClosing();
    this._reasonLaneCloseList = await this.incidentService._reasonCloseList.value;
  }

  async getITSReasonsOpening() {
    await this.incidentService.getITSReasonsOpening();
    this._reasonLaneOpenList = await this.incidentService._reasonOpenList.value;
  }

  getVehicleModel(modelID) {
    if(!this._vehicleModelFullList.length) {  this._vehicleModelFullList = this.incidentService._vehicleModelsFullList.value;}
    return this._vehicleModelFullList.find(v => v.ModelID === modelID);
  }

  getVehicleType(vehicleModel) {;
    let type = this._vehicleTypeList.find(v => v.value === vehicleModel?.VehicleType?.TypeID)?? this._vehicleTypeList[0];
    return type;
  }

  getVehicleColor(colorID) {
    return this._vehicleColorList.find(c => c.value === colorID)?? this._vehicleColorList[0];
  }

  async getVehiclesData() {
    if(!this.incidentService._vehicleTypesList.value.length)  {
      await this.incidentService.getVehicleMakes();
      await this.incidentService.getVehicleTypes();
      await this.incidentService.getVehicleColor();
    }
    this._vehicleModelFullList = await this.incidentService._vehicleModelsFullList.value;
    this._vehicleTypeList =  await this.incidentService._vehicleTypesList.value;
    this._vehicleColorList = await this.incidentService._vehicleColorList.value;
    if(!this._vehicleModelFullList.length) {
      let makeList = this.incidentService._vehicleMakesFullList.value.map(make => {
        return make.MakeID
      });
      await this.incidentService.getITSVehicleModels(makeList);
    }
  }
  
  createITSVehicle(vehicleData: CoreTypes.ITS_VehicleSimplifiedData): Promise<CoreTypes.ITS_VehiclesData> {
    return new Promise((resolve, reject) => {
      this._coreProxyService.IncidentService.CreateITSVehicle(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        vehicleData,
        data => {
          resolve(data);
        },
        err => {
          reject(err);
          this._appService.showException(err);
          this.loadAddVehicles = 2;
        }
      )
    })
  }

  async getPeopleData() {
    if(!this.incidentService._countriesList.value.length)  {
      await this.incidentService.loadCountries();
      await this.incidentService.getDamageResponsibilities();
      await this.incidentService.getHealthConditions();
      await this.incidentService.getPersonTypes();
      await this.incidentService.getITSHospitals();
    }
    if(!this.incidentService._assistenceTypeList.value.length) {
      await this.incidentService.getAssistenceTypes();
    }
    this._countries = await this.incidentService._countriesList.value;
  }
  
  async getCountry(country) {
    if(!this._countries.length) { await this.getPeopleData(); }
    return this._countries.find(c => c.value === country) ?? this._countries.find(x => x.label == 'Chile');
  }

  getPersonType(personType) {
    return this.incidentService._personTypeList.value.find(x => x.value === personType)?? this.incidentService._personTypeList.value[0]
  }

  getHospital(hospital) {
    return this.incidentService._hospitalsList.value.find(h => h.value == hospital)?? this.incidentService._hospitalsList.value[0];
  }

  async getDamageResponsability(responsibility) {
    if(!this.incidentService._responsibilitiesList?.value.length) await this.incidentService.getDamageResponsibilities();
    return this.incidentService._responsibilitiesList.value.find(x => x.value === responsibility)?? this.incidentService._responsibilitiesList.value[0]
  }

  async getHealthConditions() {
    let healthConditions = await this.incidentService.getHealthConditions();
    this.summaryConditions = healthConditions.reduce((acc, condition) => {
      acc[condition.HealthConditionID] = condition.ConditionName;
      return acc;
    }, {});
  }

  getHealthCondition(condition) {
    if(!this.incidentService._healthConditionList?.value?.length) this.getHealthConditions();
    return this.incidentService._healthConditionList.value.find(x => x.value === condition)??this.incidentService._healthConditionList.value[0];
  }

  createITSPerson(personData: CoreTypes.ITS_PersonSimplified): Promise<CoreTypes.ITS_Persons>  {
    if(!personData.CountryID) {
      personData.CountryID = this.incidentService._countriesList?.value.find(c => c.value === personData?.CountryID)?.value ?? this.incidentService._countriesList.value.find(x => x.label === 'Chile').value;
    }
    return new Promise((resolve, reject) => {
      this._coreProxyService.IncidentService.CreateITSPerson(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        personData,
        data => {
          resolve(data);
        },
        err => {
          reject(err);
          this._appService.showException(err);
          this.loadAddVehicles = 2;
        }
      )
    })
  }

  async getAssistance() {
    this._assistanceReasonList = await this.incidentService.getVehicleAssistanceReasons();
  }

  async getPersonAssistance() {
    this._personAssistanceReasonList = await this.incidentService.getPersonAssistanceReasons();
  }

  async getIncidentMaterialAssets() {
    await this.incidentService.getIncidentMaterialAssets();
    this.materialAssetsFullList = await this.incidentService._materialAssetsFullList.value;
  }

  updateMaxDate() {
    this.today = new Date();
  }
  
  refreshTabsData() {
    this.onRefreshGrid('lanes');
    this.onRefreshGrid('vehicles');
    this.onRefreshGrid('people');
    this.onRefreshGrid('dispatch');
    this.onRefreshGrid('damages');
    this.onRefreshGrid('file');
  }

  onRefreshGrid(item){
    switch(item) {
      case 'vehicles':
        const vehicleColumnsConfig = [
          { title: 'Patente', key: 'LicensePlate' },
          { title: 'Tipo', key: 'Type', alignment: 2 },
          { title: 'Color', key: 'Color', alignment: 2 },
          { title: 'Modelo', key: 'Model', alignment: 2 },
          { title: 'Año', key: 'VehicleYear', alignment: 2 },
          { title: 'Asistencia', key: 'AssistanceType', alignment: 2 },
          { title: 'Trasladado por', key: 'TransferredBy', alignment: 2 },
          { title: 'Destino', key: 'Destination', alignment: 2 },
        ];
        this._vehiclesInvolved = this.setDynamicEntries(vehicleColumnsConfig, this._vehiclesInvolvedList);
        this.onRefreshGrid('people');
        break;
      case 'lanes':
        const laneColumnsConfig = [
            { title:'Eje', alignment: 0, key: 'VialAxis', width: 65},
            { title:'Calzada', key: 'TrafficDirection', alignment: 2, width: 65},
            { title:'Via', key: 'LaneRoadway',alignment: 2, width: 65},
            { title:'Pista', key: 'Lane', alignment: 2, width: 65},
            { title:'Inicio', key: 'StartDateTime', alignment: 2,},
            { title:'Fin', key: 'EndDateTime', alignment: 2,},
            { title:'Móvil', key: 'Movil', alignment: 2,},
            { title:'Motivo', key: 'Reason', alignment: 2,},
        ];
        this._lanesInvolvedTable = this.setDynamicEntries(laneColumnsConfig, this._lanesInvolvedList);

        break;
      case 'dispatch':
        const dispatchColumnsConfig = [
          { title: 'Móvil', key: 'Movil' },
          { title: 'Despacho', key: 'DispatchDateTime', alignment: 2 },
          { title: 'Llegada', key: 'ArrivalDateTime', alignment: 2 },
          { title: 'Fin Asistencia', key: 'EndDateTime', alignment: 2 },
          { title: 'Asistencia', key: 'AssistanceType', alignment: 2 }
        ];
        this._dispatchTable = this.setDynamicEntries(dispatchColumnsConfig, this._dispatchList);
        break;
      case 'people':
        const peopleColumnsConfig = [
          { title: 'Nombre', key: 'FullName', alignment: 0 },
          // { title: 'N° Documento', key: 'DocumentNumber', alignment: 2 },
          { title: 'Tipo persona', key: 'PersonType', alignment: 2 },
          { title: 'Vehículo', key: 'Vehicle', alignment: 2 },
          { title: 'Asistencia', key: 'Assistance', alignment: 2 },
          { title: 'Condición', key: 'HealthCondition', alignment: 2 },
          { title: 'Móvil', key: 'Movil', alignment: 2 },
          { title: 'Destino', key: 'Destination', alignment: 2 },
        ];

        this._vehiclePersonList = [];
        if(!this._vehiclePersonList.length) { this._vehiclePersonList.push({ label: 'Ninguno', value:0 }) }
        this._vehiclesInvolvedList?.forEach(v => {
          this._vehiclePersonList.push({ label: v.LicensePlate, value: v.Id});
        });
        this._vehiclePerson = this._vehiclePersonList[0];
        this.incidentService.vehiclePersonList = this._vehiclePersonList;
        this._peopleInvolved = this.setDynamicEntries(peopleColumnsConfig, this._peopleInvolvedList);
        break;
      case 'damages':
        const damageColumnsConfig = [
          { title: 'Elemento', key: 'Damage' },
          { title: 'Cantidad', key: 'Quantity', alignment: 2 },
          { title: 'Comentarios', key: 'Comments', alignment: 2 },
        ];
        this._damageRegisterDataTable = this.setDynamicEntries(damageColumnsConfig, this._damageRegisterList);
        break;
      case 'file':
        const filesColumnsConfig = [
          { title: 'Nombre', key: 'FileName' },
          { title: 'Tipo', key: 'FileType', alignment: 2 },
          { title: 'Descripción', key: 'Description', alignment: 2 },
          { title: 'Fecha y Hora Creación', key: 'DateTimeCreated', alignment: 2 },
          { title: 'Fecha y Hora Modificación', key: 'DateTimeCreated', alignment: 2 },
        ];
        this._fileEvidenceTable = this.setDynamicEntries(filesColumnsConfig, this._fileEvidenceList);
        break;
      default:
        break;
    }
  }

  setDynamicEntries(columnsConfig, data) {
    const dataEntries: TableTypes.DataTable = {
      Columns: columnsConfig.map(col => ({
        Title: col.title,
        Alignment: col.alignment || 0,
        WidthPixels: col.width || 65
      })),
      Elements: this.formatDynamicElements(columnsConfig, data)
    };
    return dataEntries;
  }

  formatDynamicElements(columnsConfig, elements){
    let retElem = [];
    if (elements && elements.length > 0) {
      retElem = elements.map((x, i) => ({
        ElementID: i,
        Values: columnsConfig.map(col => x[col.key])
      }));
    }
    return retElem;
  }

  openRemoveModal(id, removeType) {
    this._removeId = id;
    this._removeType = removeType;
    this._confirmRemove.open();
  }

  remove() {
    switch (this._removeType) {
      case 'vehicle':
        if(this._vehiclesInvolvedList[this._removeId]?.Present) {
          let index = this._peopleInvolvedList.findIndex(p => p.Vehicle == this._vehiclesInvolvedList[this._removeId]?.LicensePlate)
          if(index > -1) {
            this._peopleInvolvedList.splice(index, 1);
            this._peopleInvolvedListClone.splice(index, 1);
            this.onRefreshGrid('people');
          }
          const vehicleId = this._vehiclesInvolvedList[this._removeId]?.Id;
          if (this.incidentData) this.removePersonFromVehicle(this.incidentData, vehicleId);
          if (this.incidentFileData) this.removePersonFromVehicle(this.incidentFileData, vehicleId);
        }
        this.removeElementFromTable(this.incidentElementTypes.InvolvedVehicles, this._vehiclesInvolvedList[this._removeId]?.LicensePlate);
        this._vehiclesInvolvedList.splice(this._removeId, 1);
        this._vehiclesInvolvedListClone.splice(this._removeId, 1);
        if (this.incidentData) this.incidentData.IncidentVehicles.splice(this._removeId, 1);
        if (this.incidentFileData) this.incidentFileData.IncidentVehicles.splice(this._removeId, 1);
        this.updateSummary.emit(this._vehiclesInvolvedList);
        this.onRefreshGrid('vehicles');
        break;
      case 'lanes':
        this.removeElementFromTable(this.incidentElementTypes.Lanes, this._lanesInvolvedList[this._removeId].Id);
        this._lanesInvolvedList.splice(this._removeId, 1);
        if (this.incidentData) this.incidentData.IncidentLanes.splice(this._removeId, 1);
        if (this.incidentFileData) this.incidentFileData.IncidentLanes.splice(this._removeId, 1);
        this.onRefreshGrid('lanes');
        break;
      case 'dispatch':
        this._dispatchList[this._removeId].AssistanceType = this._assistanceList.find(x => x.value === 3).label;
        const assistanceType = this._assistanceList.find(x => x.value === 3).value;
        if (this.incidentData) this.incidentData.Dispatches[this._removeId].AssistanceType = assistanceType;
        if (this.incidentFileData) this.incidentFileData.Dispatches[this._removeId].AssistanceType = assistanceType;
        this.onRefreshGrid('dispatch');
        break;
      case 'people':
        this.removeElementFromTable(this.incidentElementTypes.InvolvedPeople, this._peopleInvolvedList[this._removeId]?.DocumentNumber);
        this._peopleInvolvedList.splice(this._removeId, 1);
        this._peopleInvolvedListClone.splice(this._removeId, 1);
        if (this.incidentData) this.incidentData.IncidentPersons.splice(this._removeId, 1);
        if (this.incidentFileData) this.incidentFileData.IncidentPersons.splice(this._removeId, 1);
        this.updateSummary.emit(this._vehiclesInvolvedList);
        this.onRefreshGrid('people');
        break;
      case 'damages':
        this.removeElementFromTable(this.incidentElementTypes.DamageRegister, this._damageRegisterList[this._removeId].Id);
        this._damageRegisterList.splice(this._removeId, 1);
        if (this.incidentData) this.incidentData.IncidentDamagedMaterialAssets.splice(this._removeId, 1);
        if (this.incidentFileData) this.incidentFileData.IncidentDamagedMaterialAssets.splice(this._removeId, 1);
        this.onRefreshGrid('damages');
        break;
      case 'file':
        this._fileEvidenceList.splice(this._removeId, 1);
        if (this.incidentData) this.incidentData.IncidentAttachment.splice(this._removeId, 1);
        if (this.incidentFileData) this.incidentFileData.IncidentAttachment.splice(this._removeId, 1);
        this.onRefreshGrid('file');
        break
      default:
        break;
    }
    this._confirmRemove.close();
  }

  private removePersonFromVehicle(data, vehicleId) {
    if (!data?.IncidentPersonVehicles || !data?.IncidentPersons) return;
  
    const indexP = data.IncidentPersonVehicles.findIndex(x => x.IncidentVehicleID === vehicleId);
    if (indexP > -1) {
      const personId = data.IncidentPersonVehicles[indexP].IncidentPersonID;
      const indexPerson = data.IncidentPersons.findIndex(x => x.PersonID === personId);
      if (indexPerson > -1) data.IncidentPersons.splice(indexPerson, 1);
      data.IncidentPersonVehicles.splice(indexP, 1);
    }
  }

  openAddModal(type: any) {
    this.incidentElements = null;
    this.incidentElements = {
      IncidentElementTypeID: type,
      JsonData: '',
      Editing: false,
      IncidentID: this.incidentID
    }
    this.cdRef.detectChanges();
    this._elementModal.open(this.incidentElements);
  }

  openEditSelectedElement(id: number, editType: string, title?: string, dataType: 'incident' | 'fileData' = 'incident') {
    this._editId = id;
    this._editType = editType;
    this._editTitle = title;
    this.updateMaxDate();

    const dataSourceMap: { [key: string]: any } = {
      incident: this.incidentData,
      fileData: this.incidentFileData
    };
  
    const currentDataSource = dataSourceMap[dataType];
    if (!currentDataSource) return;

    const editConfig: { [key: string]: () => void } = {
      dispatch: () => {
        const clone = new CoreTypes.ITS_IncidentAssistanceDispatch();
        this.setIncidentElement(clone, currentDataSource.Dispatches?.[id], this.incidentElementTypes.Dispatches);
      },
      lanes: () => {
        const clone = new CoreTypes.ITS_IncidentLanes();
        this.setIncidentElement(clone, currentDataSource.IncidentLanes?.[id], this.incidentElementTypes.Lanes);
      },
      vehicle: () => {
        const clone = {
          ...new CoreTypes.ITS_VehiclesData(),
          ...new CoreTypes.ITS_Persons(),
          ...new CoreTypes.ITS_IncidentVehicles()
        };
        this.involvedVehicleClone = JSON.parse(JSON.stringify(this._vehiclesInvolvedListClone[id]));
        this.setIncidentElement(clone, this.involvedVehicleClone, this.incidentElementTypes.InvolvedVehicles);
      },
      people: () => {
        const clone = { ...new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
        this.involvedPersonClone = JSON.parse(JSON.stringify(this._peopleInvolvedListClone[id]));
        this.setIncidentElement(clone, this.involvedPersonClone, this.incidentElementTypes.InvolvedPeople);
      },
      damages: () => {
        const clone = new CoreTypes.ITS_IncidentDamagedMaterialAssets();
        clone.MaterialAssetID = this._damageRegisterList?.[id]?.Id;
        clone.Quantity = this._damageRegisterList?.[id]?.Quantity;
        clone.Comments = this._damageRegisterList?.[id]?.Comments;
        this.setIncidentElement(clone, null, this.incidentElementTypes.DamageRegister);
        this.cdRef.detectChanges();
      },
      file: () => {
        const file = this._fileEvidenceList[id];
        this.setIncidentElement(null, file, this.incidentElementTypes.Files);
        this.cdRef.detectChanges();
      }
    };
  
    const handler = editConfig[editType];
    if (handler) { handler(); } 
  }
  
  private setIncidentElement(clone: any, source: any, elementTypeID: number) {
    const elementData = source ? JSON.parse(JSON.stringify(source)) : clone;
    this.incidentElements = {
      IncidentElementTypeID: elementTypeID,
      JsonData: JSON.stringify(elementData),
      Editing: true,
      IncidentID: this.incidentID
    };
    this._elementModal.open(this.incidentElements);
  }

  downloadFileTable(pos){
    this._fileEvidenceList[pos]?.Url ? this._appService.downloadFiles(this._fileEvidenceList[pos]?.Url, this._fileEvidenceList[pos]?.Url) :
    this._appService.downloadFiles(this._fileEvidenceList[pos]?.File, this._fileEvidenceList[pos]?.FileName)
  }

  onCloseSettings(event) {
    setTimeout(() => this.incidentElements = null, 100);
  }

  saveDataElements(params) {
    switch (params?.IncidentElementTypeID) {
      case this.incidentElementTypes.Dispatches:
        let assistance = JSON.parse(params.JsonData);
        
        if(params.Editing) {
          this._assistanceClone = assistance;
          this.onEditDispatch(this._editId)
        } else {
          this.addDispatch(assistance);
        }
        break;
      case this.incidentElementTypes.Lanes:
        let lane: CoreTypes.ITS_IncidentLanes = JSON.parse(params.JsonData);
        if(params.Editing) {
          this._laneClone = lane;
          this.onEditLane(this._editId);
        } else {
          this.addLane(lane, lane?.RoadwayID);
        }
        break;
      case this.incidentElementTypes.InvolvedVehicles:
        let vehicle = JSON.parse(JSON.stringify(params.JsonData));
        if(params.Editing) {
          this.involvedVehicleClone = vehicle;
          this.onEditVehicle(this._editId);
        } else {
          this.addVehicle(vehicle);
        }
        break;
      case this.incidentElementTypes.InvolvedPeople:
        let person = JSON.parse(JSON.stringify(params.JsonData));
        if(params.Editing) {
          this.involvedPersonClone = person;
          this.onEditPeople(this._editId);
        } else {
          this.addPeople(person);
        }
        break;
      case this.incidentElementTypes.DamageRegister:
        let parameters = JSON.parse(params?.JsonData);
        if(!params.Editing) {
            this.addDamage(parameters);
          } else {
            this.onEditDamages(parameters);
            this.onRefreshGrid('damages');
          }
        break;
      case this.incidentElementTypes.Files:
        let files = JSON.parse(params?.JsonData);
        !params.Editing ? this.addAttachments(files) : this.onEditFile(this._editId, files);
        break;
      default:
        break;
    }
  }
  
  async setIncidentLanes() {
    const data = this.incidentData?.IncidentLanes || this.incidentFileData?.IncidentLanes
    if(data?.length){
      if(!this._trafficDirectionsList?.length || !this._vialAxesList?.length) {
        await new Promise(resolve => { setTimeout(() => resolve(null), 500); });
      }
      data.forEach(x => {
        let rodway = this._roadwayFullList?.find(y => y.VialAxisID === x.RoadwayID);
        let direction = this._trafficDirectionsList.find(t => t.value === x?.DirectionID)?.label ?? this._trafficDirectionsList[0]?.label;
        let vialAxes =  this._vialAxesList.find(axes => axes.value === rodway?.VialAxisID)?.label ?? this._vialAxesList[0]?.label;
        let laneRoadway = this._laneRoadwayList.find(l => l.value === x?.RoadwayID)?.label ?? this._laneRoadway?.label;
        let lane = this._laneFullList.find(l => l.LaneID === x.LaneID)?.LaneName;
        let reason = x.OpeningReasonID ? this._reasonLaneOpenList?.find(l => l.value === x.OpeningReasonID) : this._reasonLaneCloseList?.find(l => l.value === x.ClosureReasonID);
        let movil = this.incidentService._assistanceDispacthList?.find(t => t.VehicleID && t.VehicleID === x.EmergencyVehicleID);
        this._lanesInvolvedList.push({
          Id: x.LaneID,
          VialAxis: vialAxes,
          TrafficDirection: direction,
          LaneRoadway: laneRoadway,
          Lane: lane,
          StartDateTime: this.formatDate(x?.ClosureStartDateTime),
          EndDateTime: this.formatDate(x?.ClosureEndDateTime),
          Movil: movil?.Movil,
          Reason: reason?.label
        });

        if(!x.ClosureEndDateTime || !x.ClosureEndDateTime?.Date?.Day) {
          this.addItemToSection(this.incidentElementTypes.Lanes, x.LaneID);
        }
      });
      setTimeout(() => this.onRefreshGrid('lanes'), 100);
    }
    this.loadDataLanes = 0;
  }

  async setDispatch() {
    const data = this.incidentData?.Dispatches || this.incidentFileData?.Dispatches
    if(data?.length) {
      if(!this._assistanceList.length) {
        this._assistanceList = await this.incidentService._assistenceTypeList.value;
      }
      if(!this._movilList?.length) { await this.getAssets(); }
      if(!this._assistanceList.length) { await this.getITSAssistanceTypes(); }
      
      data.forEach(d => {
        let assistance = this._assistanceList.find(a => a.value === d.AssistanceType)?? this._assistanceList[0];
        let movil = this.findMovil(d);
        this._dispatchList.push({
          Id: d.VehicleID ? d.VehicleID : d.ServiceID,
          Movil: movil?.label,
          AssistanceType: assistance?.label,
          DispatchDateTime: this.formatDate(d.DispatchDateTime),
          ArrivalDateTime: this.formatDate(d.ArrivalDateTime),
          DepartureDateTime: this.formatDate(d.DepartureDateTime),
          EndDateTime: this.formatDate(d.EndDateTime),
          VehicleID: d.VehicleID,
          ServiceID: d.ServiceID
        });
        if(d.ServiceID) {
          let item = { Movil: movil, ServiceID: d.ServiceID}
          this.incidentService._assistanceDispacthList?.push(item);
        }
        this.addItemToSection(this.incidentElementTypes.Dispatches,(d.VehicleID ?  d.VehicleID : d.ServiceID))
      });
      this.loadAssistances = 0;
      setTimeout(() => this.onRefreshGrid('dispatch'), 100);
    }
  }

  setInvolvedVehicles() {    
    this.getVehiclesData().then(async () => {
      const data = this.incidentData || this.incidentData
      if(data?.IncidentVehicles?.length) {
        if(!this._assistanceReasonList?.length) {
          await this.getAssistance();
        }
        for (let i = 0; i < data?.IncidentVehicles.length; i++) {
          const d =  data?.IncidentVehicles[i];
          let result = this.vehicleDataFullList.find(v => v.VehicleDataID === d.VehicleDataID)
          let vehicleModel = this.getVehicleModel(result.ModelID);
          let vehiclePerson = data.IncidentPersonVehicles.find(p => p.IncidentVehicleID == result.VehicleDataID);
          let owner: CoreTypes.ITS_Persons;
          if(vehiclePerson?.IncidentPersonID && this.personDataFullList.length) {
            owner = this.personDataFullList.length && this.personDataFullList.find(v => v.PersonID === vehiclePerson.IncidentPersonID) ?
            this.personDataFullList.find(v => v.PersonID === vehiclePerson.IncidentPersonID) :
            await this.incidentService.getITSPerson(vehiclePerson?.IncidentPersonID);
          } else if(result?.VehicleOwnerID){
            owner = await this.incidentService.getITSPerson(result?.VehicleOwnerID);
          }

          let incidentPersonVehiclesList = data.IncidentPersonVehicles?.find(i => i?.IncidentVehicleID === d.VehicleDataID);
          let personPresent = data.IncidentPersons?.find(p => p.PersonID === incidentPersonVehiclesList?.IncidentPersonID);
          let assistanceReason = this._assistanceReasonList?.find(x => x.VehicleAssistanceReasonID === d.AssistanceType);
          let transferResponsible = this.incidentService._assistanceDispacthList?.find(t => (t.VehicleID && t.VehicleID === d.TransferredBy) ||
          (t.ServiceID && t.ServiceID === d.TransferredBy))?.Movil;
          await new Promise(resolve => { setTimeout(() => resolve(null), 10); })
          let involverVehicle = {
            Id: d.VehicleDataID,
            LicensePlate: result.LicensePlate,
            Type: this.getVehicleType(vehicleModel)?.label,
            Color: this.getVehicleColor(result.ColorID)?.label,
            Model: vehicleModel?.ModelDisplay,
            VehicleYear: result?.VehicleYear,
            AssistanceType: assistanceReason?.VehicleAssistanceReasonDescription,
            TransferredBy: transferResponsible,
            Destination: d.Destination,
            DocumentNumber: owner?.DocumentNumber,
            Name: owner?.FirstName,
            LastName: owner?.LastName,
            PersonType: personPresent ? personPresent?.PersonTypeID : 0,
            Email: result.Email,
            MobilePhone: result.MobilePhone,
            VehicleOwnerID: result.VehicleOwnerID,
            Present: personPresent?.PersonTypeID ? true: false,
            // OtherPersonType: personPresent?.OtherPersonType
          }
          this._vehiclesInvolvedList.push(involverVehicle);
          let cloneInvolverVehicle = JSON.parse(JSON.stringify(involverVehicle))
          this.addItemToSection(this.incidentElementTypes.InvolvedVehicles, involverVehicle.LicensePlate);
          delete cloneInvolverVehicle.AssistanceType;
          delete cloneInvolverVehicle.Name;
          delete cloneInvolverVehicle.Model;
          delete cloneInvolverVehicle.Type;
          delete cloneInvolverVehicle.TransferredBy
          const allObjects = {...d, ...result, ...owner, ...incidentPersonVehiclesList, ...cloneInvolverVehicle};
          if(!this._vehiclesInvolvedListClone?.length) this._vehiclesInvolvedListClone = [];
          this._vehiclesInvolvedListClone.push(JSON.parse(JSON.stringify(allObjects)));
        }
      }
      await new Promise(resolve => { setTimeout(() => resolve(null), 100); });
      this.loadDataVehicles = 0;
      this.refreshGridSafely('vehicles');
      this.updateSummary.emit(this._vehiclesInvolvedList);

    }).catch(_ => {
      this.loadDataVehicles = 2;
    });
  }

  async setInvolvedPerson(personData:CoreTypes.ITS_Persons[] ) {
    this.getPeopleData().then(async data => {
      const peopleData =  this.incidentData || this.incidentFileData
      if(peopleData?.IncidentPersons?.length) {
        await this.getPersonAssistance();
        peopleData?.IncidentPersons?.forEach(d => {
          let result = personData.find(v => v.PersonID === d.PersonID);
          let incidentPersonVehiclesList = peopleData.IncidentPersonVehicles?.find(i => i.IncidentPersonID === d.PersonID);
          let personType = this.incidentService._personTypeList?.value?.find(p => p.value === d.PersonTypeID) ?? this.incidentService._personTypeList.value.find(x => x.value === 4);
          let country = this.incidentService._countriesList.value.find(c => c.value === result?.CountryID) ?? this.incidentService._countriesList.value.find(x => x.label === 'Chile')
          let vehicleData = this.vehicleDataFullList.find(v => v.VehicleDataID === incidentPersonVehiclesList?.IncidentVehicleID)
          let healthCondition = this.getHealthCondition(d.HealthConditionID);
          this._peopleInvolvedList.push({
            Id: d.PersonID,
            Vehicle: vehicleData?.LicensePlate ? vehicleData?.LicensePlate : this._appService.CoreCommonLiterals.None_Male,
            DocumentTypeID: result?.DocumentTypeID,
            DocumentNumber: result?.DocumentNumber,
            FullName: result?.FirstName + ' ' + result?.LastName,
            Country: country?.label,
            HealthCondition: healthCondition?.label,
            PersonID: d.PersonID,
            Hospital: this.getHospital(d.HospitalID)?.label,
            PersonType: personType?.label,
            Destination: this.getHospital(d.HospitalID)?.value || !d.Destination ? this.getHospital(d.HospitalID)?.label : d.Destination
          });
          if(!this._peopleInvolvedListClone.length) this._peopleInvolvedListClone = [];
          let involvedPeople: ITS_PersonsData = {Id: d.PersonID, ...d, ...result, VehicleDataID: vehicleData?.VehicleDataID};
          this._peopleInvolvedListClone.push(JSON.parse(JSON.stringify(involvedPeople)));
          this.addItemToSection(this.incidentElementTypes.InvolvedPeople, result.DocumentNumber);
        });
        this.updateSummary.emit(this._vehiclesInvolvedList);

      }
      await new Promise(resolve => { setTimeout(() => resolve(null), 200); });
      this.onRefreshGrid('people');
      this.loadDataPersons = 0;
    });
  }

  setDamagedMaterialAssets() {
    const data =  this.incidentData || this.incidentFileData;
    if(data?.IncidentDamagedMaterialAssets?.length) {
      data?.IncidentDamagedMaterialAssets?.forEach(async a => {
        let damage = this.materialAssetsFullList.find(d => d.MaterialAssetID === a.MaterialAssetID);
        this._damageRegisterList.push({
          Id: a.MaterialAssetID,
          Damage: damage?.MaterialAssetDescription,
          Quantity: a?.Quantity,
          Comments: a?.Comments
        });
        this.addItemToSection(this.incidentElementTypes.DamageRegister, a.MaterialAssetID);
      });
    }

    setTimeout(() => this.onRefreshGrid('damages'), 100);
  }

  setAttachment() {
    const data =  this.incidentData || this.incidentFileData;
    if(data?.IncidentAttachment?.length) {
      data?.IncidentAttachment?.forEach(async a => {
        let fileType = this.getFileType(a.FileName);
        this._fileEvidenceList.push({
          FileName: a.FileName,
          Description: a.Description,
          File64: a.File.ContentBase64,
          FileType: fileType,
          FileAssetID:a.File.FileAssetID,
          IsPublic: true,
          Url: a.File.Url,
          IncidentAttachmentID: a.IncidentAttachmentID,
          IncidentID: this.incidentID ? this.incidentID : 0,
        });
      });
    }
    setTimeout(() => this.onRefreshGrid('file'), 100);
  }


  async addDispatch(assistance: ITS_Dispatches) {
    const movilID = assistance.VehicleID || assistance.ServiceID;
    if (!assistance || movilID === 0) return;

    const existingDispatch = this._dispatchList.find(x => x.Id === movilID);
    if (existingDispatch) {
      this.addItemToSection(this.incidentElementTypes.Dispatches, movilID);
      this.refreshGridSafely('dispatch');
      return;
    }
  
    if (!this._externalMovilList?.length) { await this.getITSExternalAssistanceServices(); } 
    if(!this._movilList?.length) { await this.getAssets(); }
    if(!this._assistanceList.length) { await this.getITSAssistanceTypes(); }
    const movil = this.findMovil(assistance);
    const assistanceType = this._assistanceList?.find(a => a.value === assistance.AssistanceType);
  
    if (this.incidentData && !this.incidentData.Dispatches?.length) { this.incidentData.Dispatches = []; }
    if (this.incidentFileData && !this.incidentFileData.Dispatches?.length) { this.incidentFileData.Dispatches = []; }
    const newDispatch = this.createDispatchEntry(assistance, movilID, movil, assistanceType);
    if (this.incidentData) this.incidentData.Dispatches.push(newDispatch);
    if (this.incidentFileData) this.incidentFileData.Dispatches.push(newDispatch);

    this.updateDispatchList(newDispatch, movil, assistanceType);
    this.addItemToSection(this.incidentElementTypes.Dispatches, movilID);
    this.refreshGridSafely('dispatch');
  }
  
  private findMovil(assistance: ITS_Dispatches) {
    return assistance.VehicleID ? this._movilList?.find(m => m.value === assistance.VehicleID)
    : this._externalMovilList?.find(e => e.value === assistance.ServiceID);
  }

  private createDispatchEntry(
    assistance: ITS_Dispatches,
    movilID: number,
    movil: any,
    assistanceType: any
  ): ITS_Dispatches {
    return {
      ArrivalDateTime: this.parseDateTime(assistance.ArrivalDateTime),
      AssistanceType: assistance.AssistanceType,
      DepartureDateTime: this.parseDateTime(assistance.DepartureDateTime),
      DispatchDateTime: assistance.DispatchDateTime,
      DispatchID: 0,
      EmergencyVehicleID: undefined,
      HasArrived: !!assistance.ArrivalDateTime?.Date?.Day,
      HasAttended: !!assistance.DepartureDateTime?.Date?.Day,
      HasDeparture: !!assistance.DepartureDateTime?.Date?.Day,
      IncidentID: this.incidentID ? this.incidentID : 0,
      LicensePlate: assistance.LicensePlate,
      ServiceID: assistance.ServiceID || undefined,
      VehicleID: assistance.VehicleID || undefined,
      EndDateTime: this.parseDateTime(assistance.EndDateTime),
      HasEnded: !!assistance.EndDateTime?.Date?.Day,
      Reference: assistance.Reference,
      TransferEndDateTime: assistance.TransferEndDateTime,
      Observation: assistance.Observation,
      Identification: assistance.Identification
    };
  }
  
  private updateDispatchList(dispatch: ITS_Dispatches, movil: any, assistanceType: any) {
    this._dispatchList.push({
      Id: dispatch.VehicleID || dispatch.ServiceID,
      Movil: movil?.label,
      AssistanceType: assistanceType?.label,
      DispatchDateTime: this.formatDate(dispatch.DispatchDateTime),
      ArrivalDateTime: this.formatDate(dispatch.ArrivalDateTime),
      DepartureDateTime: this.formatDate(dispatch.DepartureDateTime),
      EndDateTime: this.formatDate(dispatch.EndDateTime),
      ServiceID: dispatch.ServiceID || undefined,
      VehicleID: dispatch.VehicleID || undefined
    });
    if(!this.incidentService._assistanceDispacthList?.length) this.incidentService._assistanceDispacthList = [];
    let item = {
      Movil : this._dispatchList[this._dispatchList?.length-1]?.Movil,
      ServiceID: this._dispatchList[this._dispatchList?.length-1]?.ServiceID,
      VehicleID: this._dispatchList[this._dispatchList?.length-1]?.VehicleID
    }
    this.incidentService._assistanceDispacthList.push(item);
  }
  
  onEditDispatch(Id: number) {
    const dispatchClone = this._assistanceClone;
    const movil = dispatchClone.VehicleID ? this._movilList?.find(m => m.value === dispatchClone.VehicleID) : this._externalMovilList?.find(e => e.value === dispatchClone.ServiceID);
    
    const assistanceType = this._assistanceList?.find(a => a.value === dispatchClone.AssistanceType);
    const oldID = this._dispatchList[Id].Id;
    
    const dispatch = this.incidentData.Dispatches[Id] || this.incidentFileData.Dispatches[Id];
    dispatch.ArrivalDateTime = this.parseDateTime(dispatchClone.ArrivalDateTime);
    dispatch.HasArrived = Boolean(dispatchClone.ArrivalDateTime?.Date?.Day);
  
    dispatch.DepartureDateTime = this.parseDateTime(dispatchClone.DepartureDateTime);
    dispatch.HasDeparture = Boolean(dispatchClone.DepartureDateTime?.Date?.Day);
  
    dispatch.DispatchDateTime = this.parseDateTime(dispatchClone.DispatchDateTime);
    dispatch.HasAttended = Boolean(dispatchClone.DispatchDateTime?.Date?.Day);
  
    dispatch.EndDateTime = this.parseDateTime(dispatchClone.EndDateTime);
    dispatch.HasEnded = Boolean(dispatchClone.EndDateTime?.Date?.Day);
  
    dispatch.VehicleID = dispatchClone.VehicleID || undefined;
    dispatch.ServiceID = dispatchClone.ServiceID || undefined;
    dispatch.AssistanceType = dispatchClone.AssistanceType;
    dispatch.LicensePlate = dispatchClone.LicensePlate;
    dispatch.Reference = dispatchClone.Reference;
    dispatch['TransferEndDateTime'] = dispatchClone.TransferEndDateTime;
    dispatch['Observation'] = dispatchClone.Observation;
    dispatch['Identification'] = dispatchClone.Identification;

    const updatedDispatchListItem = this._dispatchList[Id];
    updatedDispatchListItem.Id = dispatchClone.VehicleID || dispatchClone.ServiceID;
    updatedDispatchListItem.Movil = movil?.label;
    updatedDispatchListItem.AssistanceType = assistanceType?.label;
    updatedDispatchListItem.DispatchDateTime = this.formatDate(dispatchClone.DispatchDateTime);
    updatedDispatchListItem.ArrivalDateTime = this.formatDate(dispatchClone.ArrivalDateTime);
    updatedDispatchListItem.DepartureDateTime = this.formatDate(dispatchClone.DepartureDateTime);
    updatedDispatchListItem.EndDateTime = this.formatDate(dispatchClone.EndDateTime);
  
    const indexDispatch = this.incidentService._assistanceDispacthList.findIndex(
      x => x.VehicleID === oldID || x.ServiceID === oldID
    );
  
    if (indexDispatch > -1) {
      this.incidentService._assistanceDispacthList[indexDispatch] = {
        Movil: movil?.label,
        VehicleID: dispatchClone.VehicleID,
        ServiceID: dispatchClone.ServiceID
      };
    } else {
      this.incidentService._assistanceDispacthList.push({
        Movil: movil?.label,
        VehicleID: dispatchClone.VehicleID,
        ServiceID: dispatchClone.ServiceID
      });
    }
    this.addItemToSection(this.incidentElementTypes.Dispatches, updatedDispatchListItem.Id);
    this.refreshGridSafely('dispatch');
  }

  async addLane(lane: CoreTypes.ITS_IncidentLanes, laneRoadwayID: number) {
    if (!lane || lane.LaneID === 0) return;
  
    const findLane = this._laneFullList.find(l => l.LaneID === lane.LaneID);
    const laneRoadway = this._laneRoadwayList.find(r => r.value === laneRoadwayID);
    const trafficDirection = this._trafficDirectionsList.find(t => t.value === lane.DirectionID);
  
    const existingLane = this._lanesInvolvedList.find(x => x.Id === findLane?.LaneID && !x.EndDateTime);
    if (existingLane) return;
  
    await Promise.all([
      this.onSelectTrafficDirection(),
      this.getITSReasonsClosing(),
      this.getITSReasonsOpening()
    ]);

    const movil = this.incidentService._assistanceDispacthList?.find(
      t => t.VehicleID && t.VehicleID === lane.EmergencyVehicleID
    );
    const reason = lane.OpeningReasonID
      ? this._reasonLaneOpenList.find(x => x.value === lane.OpeningReasonID)
      : this._reasonLaneCloseList.find(x => x.value === lane.ClosureReasonID);
  
    if (this.incidentData && !this.incidentData.IncidentLanes) this.incidentData.IncidentLanes = [];
    if (this.incidentFileData && !this.incidentFileData.IncidentLanes) this.incidentFileData.IncidentLanes = [];

    if (!this._lanesInvolvedList) this._lanesInvolvedList = [];
  
    const newLane = {
      LaneID: lane.LaneID,
      ClosureEndDateTime: this.parseDateTime(lane.ClosureEndDateTime),
      HasEnded: !!lane.ClosureEndDateTime?.Date?.Day,
      IncidentID: this.incidentID ? this.incidentID : 0,
      RoadwayID: laneRoadwayID,
      ClosureStartDateTime: lane.ClosureStartDateTime,
      ClosureDuration: 0,
      ClosureLength: 0,
      EndKilometerPoint: lane.EndKilometerPoint ? +lane.EndKilometerPoint : lane.EndKilometerPoint,
      IncidentLaneID: 0,
      StartKilometerPoint: lane.StartKilometerPoint ? +lane.StartKilometerPoint : lane.StartKilometerPoint,
      ClosureReasonID: lane.ClosureReasonID,
      OpeningReasonID: lane.OpeningReasonID,
      EmergencyVehicleID: lane.EmergencyVehicleID,
      DirectionID: lane.DirectionID
    };

    if(this.incidentData) this.incidentData.IncidentLanes.push(newLane);
    if(this.incidentFileData) this.incidentFileData.IncidentLanes.push(newLane);
  
    this._lanesInvolvedList.push({
      Id: lane.LaneID,
      VialAxis: this.vialAxes?.label,
      TrafficDirection: trafficDirection?.label,
      LaneRoadway: laneRoadway?.label,
      Lane: findLane?.LaneName,
      StartDateTime: this.formatDate(lane.ClosureStartDateTime),
      EndDateTime: this.formatDate(lane.ClosureEndDateTime),
      Movil: movil?.Movil,
      Reason: reason?.label
    });

    if (!lane.ClosureEndDateTime?.Date?.Day) {
      this.addItemToSection(this.incidentElementTypes.Lanes, lane.LaneID);
    }
    setTimeout(() => this.refreshGridSafely('lanes'), 100);
  }

  async onEditLane(Id: number) {
    const laneClone = this._laneClone;
    if (!laneClone) return;
  
    const findLane = this._laneFullList?.find(l => l.LaneID === laneClone?.LaneID);
    const laneRoadway = this._laneRoadwayList?.find(r => r.value === laneClone?.RoadwayID);
    const reason = laneClone?.OpeningReasonID ? this._reasonLaneOpenList?.find(x => x.value === laneClone?.OpeningReasonID)
    : this._reasonLaneCloseList?.find(x => x.value === laneClone?.ClosureReasonID);
    const movil = this.incidentService._assistanceDispacthList?.find(t => t.VehicleID && t.VehicleID === laneClone?.EmergencyVehicleID);
    const trafficDirections = this._trafficDirectionsList.find(t => t.value === laneClone?.DirectionID);
    await this.onSelectTrafficDirection();

    const updatedLane = this.incidentData.IncidentLanes[Id] || this.incidentFileData.IncidentLanes[Id];
    if (updatedLane) {
      Object.assign(updatedLane, {
        LaneID: laneClone.LaneID,
        ClosureEndDateTime:  this.formatDate(laneClone.ClosureEndDateTime),
        HasEnded: !!laneClone.ClosureEndDateTime?.Date?.Day,
        IncidentID: this.incidentID ? this.incidentID : 0,
        RoadwayID: laneClone.RoadwayID,
        ClosureStartDateTime: laneClone.ClosureStartDateTime,
        StartKilometerPoint: laneClone.StartKilometerPoint ? +laneClone.StartKilometerPoint : null,
        EndKilometerPoint: laneClone.EndKilometerPoint ? +laneClone.EndKilometerPoint : null,
        ClosureReasonID: laneClone.ClosureReasonID,
        OpeningReasonID: laneClone.OpeningReasonID,
        EmergencyVehicleID: laneClone.EmergencyVehicleID,
        DirectionID: laneClone.DirectionID,
      });
    }
  
    const updatedLaneInvolved = this._lanesInvolvedList[Id];
    if (updatedLaneInvolved) {
      Object.assign(updatedLaneInvolved, {
        Id: laneClone.LaneID,
        VialAxis: this.vialAxes?.label,
        TrafficDirection: trafficDirections?.label,
        LaneRoadway: laneRoadway?.label,
        Lane: findLane?.LaneName,
        StartDateTime: this.formatDate(laneClone.ClosureStartDateTime),
        EndDateTime: this.formatDate(laneClone.ClosureEndDateTime),
        Movil: movil?.Movil,
        Reason: reason?.label,
      });
    }
    if (!laneClone.ClosureEndDateTime?.Date?.Day) { this.addItemToSection(this.incidentElementTypes.Lanes, laneClone.LaneID); }

    this.refreshGridSafely('lanes');
  }

  async addVehicle(involvedVehicle: IncidentTypes.ITS_VehiclesData) {
    this.loadAddVehicles = 1;
    await Promise.all([this.getVehiclesData(), this.getAssistance()]);
  
    if (!involvedVehicle?.LicensePlate) {
      this.loadAddVehicles = 0;
      return;
    }
  
    let vehicleModel = involvedVehicle.ModelID ? await this.getVehicleModel(involvedVehicle.ModelID) : null;
    if (!involvedVehicle.PersonID && involvedVehicle.DocumentTypeID && involvedVehicle.DocumentNumber && involvedVehicle.FirstName) {
      involvedVehicle.PersonID = (await this.createITSPerson(involvedVehicle)).PersonID;
    }
  
    if (!involvedVehicle.VehicleDataID) {
      involvedVehicle = await this.createOrUpdateVehicle(involvedVehicle, vehicleModel);
      if (!involvedVehicle.ModelID) {
        await this.incidentService.getITSVehicleModels([involvedVehicle.VehicleMakeID]);
        involvedVehicle.ModelID = vehicleModel?.ModelID || involvedVehicle.ModelID;
        vehicleModel = await this.getVehicleModel(involvedVehicle.ModelID);
      }
    }
  
    if (involvedVehicle.Present && involvedVehicle.DocumentNumber && involvedVehicle.FirstName && involvedVehicle.LastName) {
      await this.onSetIncidentPersonVehicles(involvedVehicle);
    }
  
    const assistanceReason = this._assistanceReasonList.find(x => x.VehicleAssistanceReasonID === involvedVehicle.AssistanceType)?.VehicleAssistanceReasonDescription;
    const transferResponsible = this.incidentService._assistanceDispacthList?.find(t => (t.VehicleID && t.VehicleID === involvedVehicle.TransferredBy) || (t.ServiceID && t.ServiceID === involvedVehicle.TransferredBy))?.Movil;
  
    if (!this._vehiclesInvolvedList.some(x => x.LicensePlate === involvedVehicle.LicensePlate)) {
      this.addInvolvedVehicle(involvedVehicle, vehicleModel, assistanceReason, transferResponsible);
    }
  
    await new Promise(resolve => { setTimeout(() => resolve(null), 200); });
    this.refreshGridSafely('vehicles');
    this.updateSummary.emit(this._vehiclesInvolvedList);
    this.loadAddVehicles = 0;
  }
  
  private async createOrUpdateVehicle(involvedVehicle: IncidentTypes.ITS_VehiclesData, vehicleModel: any) {
    const vehicleData: CoreTypes.ITS_VehicleSimplifiedData = {
      ColorID: involvedVehicle.ColorID,
      Email: involvedVehicle.Email,
      InsuranceCompanyID: involvedVehicle.InsuranceCompanyID,
      InsurancePolicy: involvedVehicle.InsurancePolicy,
      InsurancePolicyEffectiveSince: this.ensureDate(involvedVehicle.InsurancePolicyEffectiveSince),
      InsurancePolicyValidUntil: this.ensureDate(involvedVehicle.InsurancePolicyValidUntil),
      LicensePlate: involvedVehicle.LicensePlate,
      MobilePhone: involvedVehicle.MobilePhone,
      ModelID: involvedVehicle.ModelID,
      ModelName: vehicleModel?.ModelName || involvedVehicle.ModelName,
      Notes: involvedVehicle.Notes,
      VehicleMakeID: involvedVehicle.VehicleMakeID,
      VehicleOwnerID: involvedVehicle.VehicleOwnerID,
      VehicleType: vehicleModel ? (await this.getVehicleType(vehicleModel))?.value : involvedVehicle.VehicleType,
      VehicleYear: involvedVehicle.VehicleYear,
    };

    const vehicleResult = await this.createITSVehicle(vehicleData);
    return Object.assign(involvedVehicle, {
      VehicleDataID: vehicleResult.VehicleDataID,
      LicensePlate: vehicleResult.LicensePlate,
      ModelID: vehicleResult.ModelID || involvedVehicle.ModelID,
    });
  }
  
  private ensureDate(date: any): CoreTypes.DateTimeDT {
    return date?.Date?.Day ? date : new CoreTypes.DateTimeDT();
  }
  
  private addInvolvedVehicle(involvedVehicle: IncidentTypes.ITS_VehiclesData, vehicleModel: any, assistanceReason: string, transferResponsible: string) {
    this.addItemToSection(this.incidentElementTypes.InvolvedVehicles, involvedVehicle.LicensePlate);
  
    if(this.incidentData) this.incidentData.IncidentVehicles = this.incidentData.IncidentVehicles || [];
    if(this.incidentFileData) this.incidentFileData.IncidentVehicles = this.incidentFileData.IncidentVehicles || [];

    const newVehicle = {
      InsuranceCompanyID: involvedVehicle.InsuranceCompanyID,
      InsurancePolicy: involvedVehicle.InsurancePolicy,
      Notes: involvedVehicle.Notes,
      IncidentID:this.incidentID ? this.incidentID : 0,
      VehicleDataID: involvedVehicle.VehicleDataID,
      InsurancePolicyEffectiveSince: this.ensureDate(involvedVehicle.InsurancePolicyEffectiveSince),
      InsurancePolicyValidUntil: this.ensureDate(involvedVehicle.InsurancePolicyValidUntil),
      Destination: involvedVehicle.Destination,
      InsuranceIsValid: involvedVehicle.InsuranceIsValid,
      AssistanceType: involvedVehicle.AssistanceType,
      Transferred: involvedVehicle.Transferred,
      TransferredBy: involvedVehicle.TransferredBy,
    };

    if(this.incidentData) this.incidentData.IncidentVehicles.push(newVehicle);
    if(this.incidentFileData) this.incidentFileData.IncidentVehicles.push(newVehicle);
  
    this._vehiclesInvolvedList.push({
      Id: involvedVehicle.VehicleDataID,
      LicensePlate: involvedVehicle.LicensePlate,
      Type: vehicleModel?.VehicleType?.TypeName,
      Color: this.getVehicleColor(involvedVehicle.ColorID)?.label,
      Model: vehicleModel?.ModelDisplay,
      VehicleYear: involvedVehicle.VehicleYear,
      AssistanceType: assistanceReason,
      TransferredBy: transferResponsible,
      Destination: involvedVehicle.Destination,
      Present: involvedVehicle.Present,
      Email: involvedVehicle.Email,
      MobilePhone: involvedVehicle.MobilePhone,
      VehicleOwnerID: involvedVehicle.VehicleOwnerID,
      ContactAddress: involvedVehicle.ContactAddress,
      ContactPhone: involvedVehicle.ContactPhone,
      CountryID: involvedVehicle.CountryID,
      DocumentNumber: involvedVehicle.DocumentNumber,
      DocumentTypeID: involvedVehicle.DocumentTypeID,
      FirstName: involvedVehicle.FirstName,
      GenderID: involvedVehicle.GenderID,
      HasEmptyInformation: involvedVehicle.HasEmptyInformation,
      LastName: involvedVehicle.LastName,
      NeedConfirmName: involvedVehicle.NeedConfirmName,
      NeedToBeUpdated: involvedVehicle.NeedToBeUpdated,
      PersonID: involvedVehicle.PersonID,
      PersonType: involvedVehicle.PersonType,
    });
    
    this._vehiclesInvolvedListClone.push({ ...involvedVehicle });
  }
  
  async onEditVehicle(Id) {
    let vehicleModel = this.getVehicleModel(this.involvedVehicleClone.ModelID);
    if(this.incidentData && !this.incidentData?.IncidentVehicles[Id]) this.incidentData.IncidentVehicles[Id] = new CoreTypes.ITS_IncidentVehicles();
    if(this.incidentFileData && !this.incidentFileData?.IncidentVehicles[Id]) this.incidentFileData.IncidentVehicles[Id] = new CoreTypes.ITS_IncidentVehicles();
    
    this.removeElementFromTable(this.incidentElementTypes.InvolvedVehicles, this._vehiclesInvolvedList[Id]?.LicensePlate);
    if(this.involvedVehicleClone.Present && !this.involvedVehicleClone.PersonID && this.involvedVehicleClone.DocumentNumber && this.involvedVehicleClone.FirstName) {
      let person = JSON.parse(JSON.stringify(this.involvedVehicleClone))
      let personResult = await this.createITSPerson(person);
      this.involvedVehicleClone.VehicleOwnerID = personResult.PersonID;
      this.involvedVehicleClone.PersonID = personResult.PersonID;
    }

    this.onSetIncidentPersonVehicles(this.involvedVehicleClone);

    let assistanceReason = this._assistanceReasonList?.find(x => x.VehicleAssistanceReasonID === this.involvedVehicleClone.AssistanceType);
    let transferResponsible = this.incidentService._assistanceDispacthList?.find(t => (t.VehicleID && t.VehicleID === this.involvedVehicleClone.TransferredBy) ||
    (t.ServiceID && t.ServiceID === this.involvedVehicleClone.TransferredBy))?.Movil;

    const data = this.incidentData?.IncidentVehicles[Id] || this.incidentFileData?.IncidentVehicles[Id];
    const updatedVehicle = {
      Destination: this.involvedVehicleClone.Destination,
      IncidentID: data.IncidentID,
      InsuranceCompanyID: this.involvedVehicleClone.InsuranceCompanyID,
      InsurancePolicy:this.involvedVehicleClone.InsurancePolicy,
      InsurancePolicyEffectiveSince: this.involvedVehicleClone.InsurancePolicyEffectiveSince?.Date?.Day ? this.involvedVehicleClone.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
      InsurancePolicyValidUntil: this.involvedVehicleClone.InsurancePolicyValidUntil?.Date?.Day ? this.involvedVehicleClone.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
      Notes: this.involvedVehicleClone.Notes,
      VehicleDataID: this.involvedVehicleClone.VehicleDataID,
      InsuranceIsValid: this.involvedVehicleClone.InsuranceIsValid,
      AssistanceType: this.involvedVehicleClone.AssistanceType,
      Transferred: this.involvedVehicleClone.Transferred,
      TransferredBy: this.involvedVehicleClone.TransferredBy
    };
    this.updateIncidentVehicles(this.incidentData, Id, updatedVehicle);
    this.updateIncidentVehicles(this.incidentFileData, Id, updatedVehicle);

    this._vehiclesInvolvedListClone[Id] = JSON.parse(JSON.stringify(this.involvedVehicleClone));
    this._vehiclesInvolvedList[Id].Id = this.involvedVehicleClone.VehicleDataID;
    this._vehiclesInvolvedList[Id].Model = vehicleModel?.ModelDisplay;
    this._vehiclesInvolvedList[Id].Type = this.getVehicleType(vehicleModel)?.label;
    this._vehiclesInvolvedList[Id].Color = this.getVehicleColor(this.involvedVehicleClone.ColorID)?.label;
    this._vehiclesInvolvedList[Id].Present  = this.involvedVehicleClone.Present;
    this._vehiclesInvolvedList[Id].AssistanceType = assistanceReason?.VehicleAssistanceReasonDescription;
    this._vehiclesInvolvedList[Id].VehicleYear = this.involvedVehicleClone.VehicleYear;
    this._vehiclesInvolvedList[Id].TransferredBy = transferResponsible;
    this._vehiclesInvolvedList[Id].Destination = this.involvedVehicleClone.Destination;
    this.addItemToSection(this.incidentElementTypes.InvolvedVehicles, this.involvedVehicleClone.LicensePlate);
    setTimeout(() => this.refreshGridSafely('vehicles'), 300);
  }

  private updateIncidentVehicles(data, Id, updatedVehicle) {
    if (data) data.IncidentVehicles[Id] = { ...updatedVehicle };
  }
  
  async onSetIncidentPersonVehicles(involvedVehicle) {
    if(this.incidentData) {
      this.incidentData.IncidentPersonVehicles = this.incidentData.IncidentPersonVehicles || [];
      this.incidentData.IncidentPersons = this.incidentData.IncidentPersons || [];
    } 
    if(this.incidentFileData) {
      this.incidentFileData.IncidentPersonVehicles = this.incidentFileData.IncidentPersonVehicles || [];
      this.incidentFileData.IncidentPersons = this.incidentFileData.IncidentPersons || [];
    } 
  
    await this.getPeopleData();
    if (involvedVehicle.Present) await this.getPersonAssistance();
    const dataPersonVehicles = this.incidentData?.IncidentPersonVehicles || this.incidentFileData?.IncidentPersonVehicles
    const incidentPersons = this.incidentData?.IncidentPersons || this.incidentFileData?.IncidentPersons;
    const vehicleIndex = dataPersonVehicles.findIndex(x => x.IncidentVehicleID === involvedVehicle.VehicleDataID);
  
    const incidentPersonVehicles = {
      IncidentID: this.incidentID ? this.incidentID : 0,
      IncidentPersonID: involvedVehicle.PersonID,
      IncidentVehicleID: involvedVehicle.VehicleDataID,
      InsuranceCompanyID: involvedVehicle.InsuranceCompanyID,
      InsurancePolicy: involvedVehicle.InsurancePolicy,
      InsurancePolicyEffectiveSince: involvedVehicle.InsurancePolicyEffectiveSince?.Date?.Day ? involvedVehicle.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
      InsurancePolicyValidUntil: involvedVehicle.InsurancePolicyValidUntil?.Date?.Day ? involvedVehicle.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
      Notes: involvedVehicle.Notes,
      InsuranceIsValid: involvedVehicle.InsuranceIsValid
    };

    this.updateList(dataPersonVehicles, vehicleIndex, incidentPersonVehicles, involvedVehicle.Present);
  
    const newPersonData = await this.preparePersonData(involvedVehicle);
    const personIndex = incidentPersons.findIndex(x => x.PersonID === involvedVehicle.PersonID);
    this.updateList(incidentPersons, personIndex, newPersonData, involvedVehicle.Present);

    const personInvolvedData = this.buildPersonInvolvedData(involvedVehicle, newPersonData);
    const involvedIndex = this._peopleInvolvedList.findIndex(l => l.Vehicle === involvedVehicle.LicensePlate);
    this.updateList(this._peopleInvolvedList, involvedIndex, personInvolvedData, involvedVehicle.Present);
    this.updateList(this._peopleInvolvedListClone, involvedIndex, { ...involvedVehicle, ...newPersonData }, involvedVehicle.Present);
  }

  async preparePersonData(involvedVehicle) {
    const healthCondition = this.getHealthCondition(5);
    const damageResponsibility = await this.getDamageResponsability(0);
    const newPerson = involvedVehicle.PersonID ? await this.incidentService.getITSPerson(involvedVehicle.PersonID) : null;
  
    return {
      DamageResponsibilityID: damageResponsibility?.value,
      Destination: '',
      HealthConditionID: healthCondition?.value,
      PersonID: involvedVehicle.PersonID,
      PersonTypeID: involvedVehicle.PersonTypeID,
      InsuranceCompanyID: newPerson?.InsuranceCompanyID,
      InsurancePolicy: newPerson?.InsurancePolicy,
      InsurancePolicyEffectiveSince: newPerson?.InsurancePolicyEffectiveSince?.Date?.Day ? newPerson?.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
      InsurancePolicyValidUntil: newPerson?.InsurancePolicyValidUntil?.Date?.Day ? newPerson?.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
      Notes: involvedVehicle.Notes,
      InsuranceIsValid: involvedVehicle.InsuranceIsValid,
      Observations: involvedVehicle.Observations,
      AssistanceType: involvedVehicle.AssistanceType
    };
  }

  buildPersonInvolvedData(involvedVehicle, newPersonData) {
    const country = this.incidentService._countriesList?.value.find(c => c.value === involvedVehicle?.CountryID) ?? this.incidentService._countriesList.value.find(x => x.label === 'Chile');
    const healthCondition = this.getHealthCondition(5);
    const assistanceReason = this._personAssistanceReasonList.find(x => x.PersonAssistanceReasonID === involvedVehicle.AssistanceType)?.PersonAssistanceReasonDescription;
    const personType: any = this.incidentService._personTypeList?.value?.find(p => p.value === involvedVehicle.PersonType) ?? this.incidentService._personTypeFullList.value.find(x => x.MultiLangTypeName['ES_AR'] === 'Dueño')?.TypeName;
    return {
      Vehicle: involvedVehicle.LicensePlate,
      DocumentNumber: involvedVehicle.DocumentNumber,
      FullName: `${involvedVehicle.FirstName} ${involvedVehicle.LastName}`,
      DocumentTypeID: involvedVehicle.DocumentTypeID,
      Email: involvedVehicle.Email,
      Country: country?.value,
      PersonID: involvedVehicle.PersonID,
      PersonType: personType?.label ? personType?.label : personType,
      HealthCondition: healthCondition?.label,
      Assistance: assistanceReason
    };
  }

  async addPeople(involvedPeople: ITS_PersonsData) {
    this.loadAddPersons = 1;

    if (involvedPeople?.DocumentNumber) {
      await this.getPersonAssistance();

      if (!involvedPeople.PersonID) {
        const person = { ...involvedPeople };
        const personResult = await this.createITSPerson(person);
        involvedPeople.PersonID = personResult.PersonID;
      }
  
      const personExist = this._peopleInvolvedList.some(x => x.DocumentNumber === involvedPeople.DocumentNumber);
      if (!personExist) {
        this.addItemToSection(this.incidentElementTypes.InvolvedPeople, involvedPeople.DocumentNumber);
        await this.getPeopleData();

        const vehicleData = await this.incidentService.getITSVehicle(involvedPeople.VehicleDataID);
        if(this.incidentData) this.incidentData.IncidentPersons = this.incidentData.IncidentPersons || [];
        if(this.incidentFileData) this.incidentFileData.IncidentPersons = this.incidentFileData.IncidentPersons || [];

        const newPerson = {
          InsuranceCompanyID: involvedPeople?.InsuranceCompanyID,
          InsurancePolicy: involvedPeople?.InsurancePolicy,
          IncidentID: this.incidentID ? this.incidentID : 0,
          Notes: involvedPeople?.Notes,
          PersonID: involvedPeople.PersonID,
          DamageResponsibilityID: involvedPeople?.DamageResponsibilityID,
          HealthConditionID: involvedPeople?.HealthConditionID,
          HospitalID: involvedPeople?.HospitalID,
          InsurancePolicyEffectiveSince: involvedPeople?.InsurancePolicyEffectiveSince?.Date?.Day ? involvedPeople?.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
          InsurancePolicyValidUntil: involvedPeople?.InsurancePolicyValidUntil?.Date?.Day ? involvedPeople?.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
          PersonTypeID: involvedPeople.PersonTypeID,
          Destination: involvedPeople.Destination,
          InsuranceIsValid: involvedPeople.InsuranceIsValid,
          AccountIDDeleted: involvedPeople.AccountIDDeleted,
          DateTimeCreated: involvedPeople.DateTimeCreated,
          DateTimeDeleted: involvedPeople.DateTimeDeleted,
          DateTimeUpdated: involvedPeople.DateTimeUpdated,
          EmergencyVehicleID: involvedPeople.EmergencyVehicleID,
          Enabled: involvedPeople.Enabled,
          Observations: involvedPeople.Observations,
          Transferred: involvedPeople.Transferred,
          TransferredBy: involvedPeople.TransferredBy,
          AssistanceType: involvedPeople.AssistanceType
        };

        if(this.incidentData) this.incidentData.IncidentPersons.push(newPerson);
        if(this.incidentFileData) this.incidentFileData.IncidentPersons.push(newPerson);
  
        if (involvedPeople.VehicleDataID) {
          if(this.incidentData) this.incidentData.IncidentPersonVehicles = this.incidentData.IncidentPersonVehicles || [];
          if(this.incidentFileData) this.incidentFileData.IncidentPersonVehicles = this.incidentFileData.IncidentPersonVehicles || [];
         
          const personVehicle = {
            InsuranceCompanyID: involvedPeople?.InsuranceCompanyID,
            InsurancePolicy: involvedPeople?.InsurancePolicy,
            IncidentID: this.incidentID ? this.incidentID : 0,
            Notes: involvedPeople?.Notes,
            IncidentPersonID: involvedPeople.PersonID,
            IncidentVehicleID: involvedPeople.VehicleDataID,
            InsurancePolicyEffectiveSince: involvedPeople?.InsurancePolicyEffectiveSince?.Date?.Day ? involvedPeople?.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
            InsurancePolicyValidUntil: involvedPeople?.InsurancePolicyValidUntil?.Date?.Day ? involvedPeople?.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
            InsuranceIsValid: involvedPeople.InsuranceIsValid
          };
          if(this.incidentData) this.incidentData.IncidentPersonVehicles.push(personVehicle);
          if(this.incidentFileData) this.incidentFileData.IncidentPersonVehicles.push(personVehicle);
        }

        const country = await this.getCountry(involvedPeople.CountryID);
        const healthCondition = await this.getHealthCondition(involvedPeople.HealthConditionID);
        const personType = this.getPersonType(involvedPeople.PersonTypeID);
        const hospital = this.getHospital(involvedPeople.HospitalID);
        const assistanceReason = this._personAssistanceReasonList.find(x => x.PersonAssistanceReasonID === involvedPeople.AssistanceType)?.PersonAssistanceReasonDescription;
        const transferResponsible = this.incidentService._assistanceDispacthList?.find(t => (t.VehicleID && t.VehicleID === involvedPeople.TransferredBy) || (t.ServiceID && t.ServiceID === involvedPeople.TransferredBy))?.Movil;

        if (!this._peopleInvolvedList?.length) { this._peopleInvolvedList = []; }
        this._peopleInvolvedList.push({
          Id: involvedPeople.PersonID,
          Vehicle: vehicleData?.LicensePlate || this._appService.CoreCommonLiterals.None_Male,
          DocumentTypeID: involvedPeople.DocumentTypeID,
          DocumentNumber: involvedPeople.DocumentNumber,
          FullName: `${involvedPeople.FirstName} ${involvedPeople.LastName}`,
          Country: country?.label,
          HealthCondition: healthCondition?.label,
          PersonID: involvedPeople.PersonID,
          Hospital: hospital?.label,
          Assistance: assistanceReason,
          PersonType: personType?.label,
          Destination: hospital?.value || !involvedPeople.Destination ? hospital?.label : involvedPeople.Destination,
          Movil: transferResponsible
        });
  
        if (!this._peopleInvolvedListClone?.length) {
          this._peopleInvolvedListClone = [];
        }
        this._peopleInvolvedListClone.push({ ...involvedPeople });
        this.involvedPerson = { ...new CoreTypes.ITS_IncidentPersons(), ...new CoreTypes.ITS_Persons() };
        this.updateSummary.emit(this._vehiclesInvolvedList);
      }
  
      setTimeout(() => this.refreshGridSafely('people'), 100);
    }

    this.loadAddPersons = 0;
  }

  async onEditPeople(Id: number) {
    let vehicle = this._vehiclePersonList.find(v => v.value === this.involvedPersonClone.VehicleDataID) ?? this._vehiclePersonList[0];
  
    if (!this.involvedPersonClone.PersonID && this.involvedPersonClone.DocumentNumber && this.involvedPersonClone.FirstName) {
      let person = { ...this.involvedPersonClone };
      let personResult = await this.createITSPerson(person);
      this.involvedPersonClone.PersonID = personResult?.PersonID;
    }
  
    const [healthCondition, assistanceReason, transferResponsible] = await Promise.all([
      this.getHealthCondition(this.involvedPersonClone.HealthConditionID),
      this._personAssistanceReasonList?.find(x => x.PersonAssistanceReasonID === this.involvedPersonClone.AssistanceType)?.PersonAssistanceReasonDescription,
      this.incidentService._assistanceDispacthList?.find(t => (t.VehicleID && t.VehicleID === this.involvedPersonClone.TransferredBy) || (t.ServiceID && t.ServiceID === this.involvedPersonClone.TransferredBy))?.Movil
    ]);
  
    this.removeElementFromTable(this.incidentElementTypes.InvolvedPeople, this._peopleInvolvedList[Id]?.DocumentNumber);
  
    this._peopleInvolvedListClone[Id] = { ...this.involvedPersonClone };
    let updatedPerson = { ...this.involvedPersonClone };
    this._peopleInvolvedList[Id] = updatedPerson;
    this._peopleInvolvedList[Id].Id = updatedPerson.PersonID;
    this._peopleInvolvedList[Id].Vehicle = vehicle?.label;
    this._peopleInvolvedList[Id].FullName = `${updatedPerson.FirstName} ${updatedPerson.LastName}`;
    this._peopleInvolvedList[Id].Country = (await this.getCountry(updatedPerson.CountryID))?.label;
    this._peopleInvolvedList[Id].PersonType = this.getPersonType(updatedPerson.PersonTypeID)?.label;
    this._peopleInvolvedList[Id].HealthCondition = healthCondition?.label;
    this._peopleInvolvedList[Id].Assistance = assistanceReason;
    this._peopleInvolvedList[Id].Movil = transferResponsible;
    this._peopleInvolvedList[Id].Hospital = this.getHospital(updatedPerson.HospitalID)?.label;
    this._peopleInvolvedList[Id].Destination = this.getHospital(updatedPerson.HospitalID)?.value || !updatedPerson.Destination ? this._peopleInvolvedList[Id].Hospital : updatedPerson.Destination;
  
    this.addItemToSection(this.incidentElementTypes.InvolvedPeople, updatedPerson.DocumentNumber);
    let incidentPersons = this.incidentData.IncidentPersons || this.incidentFileData.IncidentPersons
    const personIndex = incidentPersons.findIndex(p => p.PersonID === updatedPerson.PersonID);
    if (personIndex !== -1) {
      const updateIncidentPerson = {
        ...incidentPersons[personIndex],
        Destination: updatedPerson.Destination,
        InsuranceCompanyID: updatedPerson.InsuranceCompanyID,
        InsurancePolicy: updatedPerson.InsurancePolicy,
        InsurancePolicyEffectiveSince: updatedPerson.InsurancePolicyEffectiveSince?.Date?.Day ? updatedPerson.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
        InsurancePolicyValidUntil: updatedPerson.InsurancePolicyValidUntil?.Date?.Day ? updatedPerson.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
        Notes: updatedPerson.Notes,
        DamageResponsibilityID: updatedPerson.DamageResponsibilityID,
        HealthConditionID: updatedPerson.HealthConditionID,
        HospitalID: updatedPerson.HospitalID || undefined,
        PersonID: updatedPerson.PersonID,
        PersonTypeID: updatedPerson.PersonTypeID,
        AccountIDDeleted: updatedPerson.AccountIDDeleted,
        DateTimeCreated: updatedPerson.DateTimeCreated,
        DateTimeDeleted: updatedPerson.DateTimeDeleted,
        DateTimeUpdated: updatedPerson.DateTimeUpdated,
        InsuranceIsValid: updatedPerson.InsuranceIsValid,
        EmergencyVehicleID: updatedPerson.EmergencyVehicleID,
        Enabled: updatedPerson.Enabled,
        Observations: updatedPerson.Observations,
        Transferred: updatedPerson.Transferred,
        TransferredBy: updatedPerson.TransferredBy,
        AssistanceType: updatedPerson.AssistanceType
      };
      this.updateIncidentPersonVehicles(this.incidentData.IncidentPersons, personIndex, updateIncidentPerson );
      this.updateIncidentPersonVehicles(this.incidentFileData.IncidentPersons, personIndex, updateIncidentPerson);
    }
    let incidentPersonVehicles = this.incidentData?.IncidentPersonVehicles || this.incidentFileData?.IncidentPersonVehicles
    
    let vehicleIndex = incidentPersonVehicles.findIndex(x => x.IncidentPersonID === updatedPerson.PersonID || x.IncidentVehicleID === this.involvedVehicleClone.VehicleDataID);
    if (vehicle.value) {
      if (vehicleIndex < 0) {
        const data =  this.incidentData?.IncidentPersons || this.incidentFileData?.IncidentPersons;
        const updatePersonVehicles = {
          IncidentID: data[Id].IncidentID,
          IncidentPersonID: updatedPerson.PersonID,
          IncidentVehicleID: updatedPerson.VehicleDataID,
          InsuranceCompanyID: updatedPerson.InsuranceCompanyID,
          InsurancePolicy: updatedPerson.InsurancePolicy,
          InsurancePolicyEffectiveSince: updatedPerson.InsurancePolicyEffectiveSince?.Date?.Day ? updatedPerson.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
          InsurancePolicyValidUntil: updatedPerson.InsurancePolicyValidUntil?.Date?.Day ? updatedPerson.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
          Notes: updatedPerson.Notes,
          InsuranceIsValid: updatedPerson.InsuranceIsValid
        };
        this.updateIncidentPersonVehicles(this.incidentData.IncidentPersonVehicles, vehicleIndex, updatePersonVehicles);
        this.updateIncidentPersonVehicles(this.incidentFileData.IncidentPersonVehicles, vehicleIndex, updatePersonVehicles);
      } else {
        const data = this.incidentData?.IncidentPersonVehicles || this.incidentFileData?.IncidentPersonVehicles
        const updatePersonVehicles = {
          ...data[vehicleIndex],
          IncidentPersonID: updatedPerson.PersonID,
          IncidentVehicleID: updatedPerson.VehicleDataID,
          InsuranceCompanyID: updatedPerson.InsuranceCompanyID,
          InsurancePolicy: updatedPerson.InsurancePolicy,
          InsurancePolicyEffectiveSince: updatedPerson.InsurancePolicyEffectiveSince?.Date?.Day ? updatedPerson.InsurancePolicyEffectiveSince : new CoreTypes.DateTimeDT(),
          InsurancePolicyValidUntil: updatedPerson.InsurancePolicyValidUntil?.Date?.Day ? updatedPerson.InsurancePolicyValidUntil : new CoreTypes.DateTimeDT(),
          Notes: updatedPerson.Notes,
          InsuranceIsValid: updatedPerson.InsuranceIsValid
        };
        this.updateIncidentPersonVehicles(this.incidentData.IncidentPersonVehicles, vehicleIndex, updatePersonVehicles);
        this.updateIncidentPersonVehicles(this.incidentFileData.IncidentPersonVehicles, vehicleIndex, updatePersonVehicles);
      }
    } else {
      if(this.incidentData) this.incidentData?.IncidentPersonVehicles.splice(vehicleIndex, 1);
      if(this.incidentFileData) this.incidentFileData.IncidentPersonVehicles.splice(vehicleIndex, 1);

    }
  
    this.updateSummary.emit(this._vehiclesInvolvedList);
    this.refreshGridSafely('people');
  }

  private updateIncidentPersonVehicles(data, Id, updatedPersonVehicles) {
    if (data) data[Id] = { ...updatedPersonVehicles };
  }

  async addDamage(damages: CoreTypes.ITS_IncidentDamagedMaterialAssets) {
    if (damages.MaterialAssetID) {
      let exist = this._damageRegisterList.find(x => x.Id == damages.MaterialAssetID);
      if (!exist){
        if(!this.materialAssetsFullList?.length) {
          await this.getIncidentMaterialAssets();
        }
        let materialAsset = this.materialAssetsFullList.find(d => d.MaterialAssetID == damages.MaterialAssetID);
        if(!this._damageRegisterList.length) this._damageRegisterList = [];
        this._damageRegisterList.push({
          Id: damages.MaterialAssetID,
          Damage: materialAsset?.MaterialAssetDescription,
          Quantity: damages.Quantity,
          Comments: damages.Comments
        });
        if(this.incidentData) this.incidentData.IncidentDamagedMaterialAssets = this.incidentData.IncidentDamagedMaterialAssets || [];
        if(this.incidentFileData) this.incidentFileData.IncidentDamagedMaterialAssets = this.incidentFileData.IncidentDamagedMaterialAssets || [];
       
        const newDamage = {
          AccountIDDeleted:damages.AccountIDDeleted,
          Comments: damages.Comments,
          DateTimeCreated: this.dateTimeCreated,
          DateTimeDeleted: damages.DateTimeDeleted,
          DateTimeUpdated: this.dateTimeCreated,
          Enabled: damages.Enabled,
          IncidentDamagedMaterialAssetsID: 0,
          IncidentID: this.incidentID ? this.incidentID : 0,
          MaterialAssetID: damages.MaterialAssetID,
          Quantity: damages.Quantity,
        };

        if(this.incidentData) this.incidentData.IncidentDamagedMaterialAssets.push(newDamage);
        if(this.incidentFileData) this.incidentFileData.IncidentDamagedMaterialAssets.push(newDamage);
  
        this.addItemToSection(this.incidentElementTypes.DamageRegister, damages.MaterialAssetID);
      }
    }
    setTimeout(() => this.refreshGridSafely('damages'), 100);
  }

  onEditDamages(parameters) {
    const { MaterialAssetID, Quantity, Comments } = parameters;
    if(this._damageRegisterList[this._editId].Id){
      let damage = this.materialAssetsFullList.find(d => d.MaterialAssetID == parameters.MaterialAssetID);
      this.removeElementFromTable(this.incidentElementTypes.DamageRegister, this._damageRegisterList[this._editId].Id)
      this._damageRegisterList[this._editId].Id = parameters.MaterialAssetID;
      this._damageRegisterList[this._editId].Damage = damage?.MaterialAssetDescription;
      this._damageRegisterList[this._editId].Quantity = parameters.Quantity;
      this._damageRegisterList[this._editId].Comments = parameters.Comments;
      this.addItemToSection(this.incidentElementTypes.DamageRegister, parameters.MaterialAssetID);

      const updateDamagedMaterialAssets = (data) => {
        data.IncidentDamagedMaterialAssets[this._editId] = {
          ...data.IncidentDamagedMaterialAssets[this._editId],
          MaterialAssetID,
          Quantity,
          Comments
        };
      };

      if (this.incidentData) updateDamagedMaterialAssets(this.incidentData);
      else if (this.incidentFileData) updateDamagedMaterialAssets(this.incidentFileData);
    }
  }
  
  addAttachments(file) {
    if(file?.File) {
      if(this.incidentData) this.incidentData.IncidentAttachment = this.incidentData?.IncidentAttachment || [];
      if(this.incidentFileData) this.incidentFileData.IncidentAttachment = this.incidentFileData.IncidentAttachment || [];
      let file64 = file.File;
      if(file64.indexOf('data:image') > -1) { file64 = file64.split(',')[1]; }
      let newAttachment: CoreTypes.IncidentAttachment = new CoreTypes.IncidentAttachment();
      newAttachment = {
        AccountID: this._appService.getAccountID(),
        FileName: file.FileName,
        DateTimeCreated: this.dateTimeCreated,
        Description: file.Description,
        File:{ ContentBase64: file64, FileAssetID:0, IsPublic: true, Url:'' },
        IncidentAttachmentID: 0,
        IncidentID: this.incidentID ? this.incidentID : 0,
      };
      file.DateTimeCreated = this.formatDate(this.dateTimeCreated);
      if(!this._fileEvidenceList?.length) this._fileEvidenceList = [];
      this._fileEvidenceList.push(file);
      if(this.incidentData) this.incidentData.IncidentAttachment.push(newAttachment);
      if(this.incidentFileData) this.incidentFileData?.IncidentAttachment?.push(newAttachment);
    }
    setTimeout(() => this.refreshGridSafely('file'), 200);
  }

  onEditFile(Id, file) {
    this._fileEvidenceList[Id].Description = file.Description;
    if(this.incidentData) {
      this.incidentData.IncidentAttachment[Id].Description = file.Description;
    } else if(this.incidentFileData) {
      this.incidentFileData.IncidentAttachment[Id].Description = file.Description;
    }
    this.onRefreshGrid('file');
  }

  cleanTableList() {
    this._dispatchTable = new TableTypes.DataTable();
    this._vehiclesInvolved = new TableTypes.DataTable();
    this._peopleInvolved = new TableTypes.DataTable();
    this._lanesInvolvedTable = new TableTypes.DataTable();
    this._damageRegisterDataTable = new TableTypes.DataTable();
    this._fileEvidenceTable = new TableTypes.DataTable();
    this._dispatchList = [];
    this.incidentService._assistanceDispacthList = [];
    this._lanesInvolvedList = [];
    this._vehiclesInvolvedList = [];
    this._vehiclesInvolvedListClone = [];
    this._peopleInvolvedList = [];
    this._peopleInvolvedListClone = [];
    this._damageRegisterList = [];
    this._fileEvidenceList = [];
    this.refreshTabsData();
  }


  updateList(list, index, data, condition) {
    if (index > -1 && condition) {
      list[index] = data;
    } else if (index > -1 && !condition) {
      list.splice(index, 1);
    } else if (index < 0 && condition) {
      list.push(data);
    }
  }
  
  private parseDateTime(dateTime: CoreTypes.DateTimeDT | undefined): CoreTypes.DateTimeDT {
    return dateTime?.Date?.Day ? dateTime : new CoreTypes.DateTimeDT();
  }
  
  private formatDate(dateTime: CoreTypes.DateTimeDT | undefined): string | null {
    return dateTime?.Date?.Day ? moment(this.stringDateTimePipe.transform(dateTime)).format('DD-MM-YYYY HH:mm') : null;
  }
  
  private refreshGridSafely(section: string) {
    try {
      this.onRefreshGrid(section);
    } catch (error) {}
  }
  
  getFileType(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    const fileType = this.fileTypeMapping[extension];
    return fileType || 'unknown';
  }

  addItemToSection(sectionId: any, item: any): void {
    this.incidentService.addItemToSection(sectionId, item);
  }

  removeElementFromTable(sectionId:any, element: any): void {
    this.incidentService.removeSelectedItem(sectionId, element);
  }

  appendModalBody(type) {
    setTimeout(() => {
      if(type === 'append') {
        document.getElementsByTagName('app-root')[0]?.appendChild(document.getElementById('confirm-remove'));
        document.getElementsByTagName('app-root')[0]?.appendChild(document.getElementById('incident-modal'));
      } else {
        document.getElementsByTagName('app-root')[0]?.removeChild(document.getElementById('confirm-remove'));
        document.getElementsByTagName('app-root')[0]?.appendChild(document.getElementById('incident-modal'));
      }
    }, 100);
  }
}
